import { render, staticRenderFns } from "./RightSideBarContent.vue?vue&type=template&id=13852b18&scoped=true&"
import script from "./RightSideBarContent.vue?vue&type=script&lang=js&"
export * from "./RightSideBarContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13852b18",
  null
  
)

export default component.exports